// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "4df1b8ea-dirty",
    "hash": "4df1b8ea",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "4df1b8ea-dirty",
    "semverString": null,
    "devVersion": "0.81.0",
    "branch": null
};
/* tslint:enable */
